const BaseView = require('./view').default;
const UiDataBuilder = require('../ui_data_builders/ui_data_builder.mobile');

module.exports = BaseView.extend({
    uiDataBuilder: new UiDataBuilder(),

    renderWrapperSavedAmountInfo(baggageUIData = {}) {
        const {isSelected} = baggageUIData;
        const primeInfo = this.getPrimeInfo();
        const {isPrimeUser, memberName} = primeInfo;
        const $savedAmountInfoBox = this.$el.find(this.selectors.baggageWrapperSavedAmountInfo);
        const savedAmount = isPrimeUser ? this.getPrimeSavedAmount() : 0;
        const hasAValidMemberName = memberName !== undefined;
        const hasAValidDiscount = savedAmount > 0;
        const showSavedAmountInfo = hasAValidDiscount
            && isPrimeUser
            && isSelected
            && hasAValidMemberName;

        if (showSavedAmountInfo) {
            const savedAmount = this.getPrimeSavedAmount() || 0;
            $savedAmountInfoBox.html(this.templates.primeRepeatSavedInfoHeader({
                keys: this.keys,
                memberName,
                savedAmount,
            }));
        }

        $savedAmountInfoBox.toggleClass('odf-hidden', !showSavedAmountInfo);
    },
});
